import { BadgeEarnedModal } from '../badges/BadgeEarnedModal';
import { useBadgeModal } from '../../hooks/useBadgeModal';

export function GlobalBadgeModal() {
  const { isOpen, currentBadge, onClose } = useBadgeModal();

  return <BadgeEarnedModal isOpen={isOpen} badge={currentBadge} onClose={onClose} />;
}
